import {PageDetailsField} from '../models/wiki';

export enum ErrorLayoutType {
    Default = 'default',
    AuthFailed = 'auth-failed',
    NoAccessInFederation = 'no-access-in-federation',
}

export enum ApiService {
    Iam = 'iam',
    OrganizationManager = 'organizationManager',
    Pages = 'pages',
}

export const SETTINGS_PAGE_SLUG = '_settings';

export const HOME_PAGE_SLUG = 'homepage';

export enum Instance {
    Business = 'business',
    Intranet = 'intranet',
}

// Переeзжать аккуратно, могут быть проблемы из-за разного кейса
export enum Header {
    AcceptLanguage = 'accept-language',
    Accept = 'accept',
    Authorization = 'authorization',

    CacheControl = 'cache-control',

    ContentType = 'content-type',
    ContentLength = 'content-length',

    Cookie = 'cookie',
    Host = 'host',

    Pragma = 'pragma',
    LastModified = 'last-modified',
    ifModifiedSince = 'if-modified-since',

    xReqId = 'x-req-id',
    xRealIp = 'x-real-ip',
    xUserIp = 'x-user-ip',
    xNginxHost = 'x-nginx-host',
    xRequestId = 'x-request-id',
    xSessionId = 'x-session-id',
    xForwardedFor = 'x-forwarded-for',

    xOrgId = 'x-org-id',
    xUid = 'x-uid',
    xCloudUid = 'x-cloud-uid',

    xYaUserTicket = 'x-ya-user-ticket',
    xYaServiceTicket = 'x-ya-service-ticket',

    xYaCloudUserTicket = 'x-ya-cloud-user-ticket',

    xYacloudSubjectToken = 'x-yacloud-subjecttoken',

    DumpsTestPath = 'dumps_test_path',

    xCollabOrgId = 'x-collab-org-id',
    xExperiment = 'x-experiment',
}

export enum GatewayInstallation {
    Russia = 'russia',
    YandexTeam = 'yandex-team',
    NoType = 'notype',
}

export enum GatewayEnv {
    Prod = 'prod',
    Preprod = 'preprod',
    NoEnv = 'noenv',
}

export enum ExperimentKey {
    CollabREST = 'collab-rest',
    ReadonlyGrids = 'readonly-grids',
    Bem = 'bem',
    Proxy = 'proxy',
    Collab = 'collab',
    WikiEditor = 'wiki-editor',
    WysiwygDefault = 'wysiwyg-default',
    Debug = 'debug',
    Informer = 'informer',
    Infobar = 'infobar',
    HTMLStreaming = 'html-streaming',
    Notes = 'notes',
    NYTheme = 'ny-theme',
    GridDialog = 'grid-dialog',
    MainLight = 'main-light',
    CollabDraft = 'collab-draft',
    // For tests
    DataUi = 'data-ui',
}

export enum MetrikaId {
    YandexTeam = 153432,
    Russia = 42770554,
    Cross = 51465824,
}

export const initialDetailsFields = [
    PageDetailsField.Breadcrumbs,
    PageDetailsField.Content,
    PageDetailsField.Access,
    PageDetailsField.LastRevisionId,
    PageDetailsField.Authors,
    PageDetailsField.Bookmark,
    PageDetailsField.Cluster,
    PageDetailsField.Subscription,
    PageDetailsField.Permissions,
    PageDetailsField.Background,
    PageDetailsField.Redirect,
    PageDetailsField.LastRevisionId,
    PageDetailsField.Actuality,
    PageDetailsField.Attributes,
];
